import { Tooltip } from '@material-ui/core';
import React from 'react';

export interface IIconPaymentMethodProps {
  cardBrand: string;
}

const IconPaymentMethod = ({ cardBrand }: IIconPaymentMethodProps) => {
  return (
    <>
      <Tooltip placement='top' title={cardBrand ? cardBrand : 'Boleto'}>
        <img
          className='my-table__payment'
          alt={cardBrand ?? 'Boleto'}
          src={cardBrand ? `/img/brands/payment/${cardBrand}.svg` : '/img/brands/payment/Boleto.svg'}
        />
      </Tooltip>
    </>
  );
};
export default IconPaymentMethod;
